import { render } from "./CollaboratorInvites.vue.js?vue&type=template&id=5239e4eb!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaboratorInvites.vue?vue&type=template&id=5239e4eb"
import script from "./CollaboratorInvites.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaboratorInvites.vue?vue&type=script&lang=js"
export * from "./CollaboratorInvites.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaboratorInvites.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/CollaboratorInvites.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5239e4eb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5239e4eb', __exports__)) {
    api.reload('5239e4eb', __exports__)
  }
  
  module.hot.accept("./CollaboratorInvites.vue.js?vue&type=template&id=5239e4eb!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollaboratorInvites.vue?vue&type=template&id=5239e4eb", () => {
    api.rerender('5239e4eb', render)
  })

}


export default __exports__